import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { useParams } from "react-router-dom";

function Editor({ data }) {
  const { name } = useParams();
  return (
    <div style={{ height: "100vh" }}>
        <iframe
          style={{width:'100vw',height:'100vh'}}
        src="https://modelviewer.dev/editor/" frameBorder="0"></iframe>
        <footer className="brand-footer">
         <a href="https://alphech.com"> <img src="/Assets/logo512.png"></img></a>
        </footer>
    </div>
  );
}

export default Editor;
